export enum ParcelDetailActionTypes {
  GET_PARCEL_DETAILS = "GET_PARCEL_DETAILS",
  GET_PARCEL_DETAILS_SUCCESS = "GET_PARCEL_DETAILS_SUCCESS",
  GET_PARCEL_DETAILS_ERROR = "GET_PARCEL_DETAILS_ERROR",
  UPDATE_PARCEL_DETAILS_LOADING_STATE = "UPDATE_PARCEL_DETAILS_LOADING_STATE",
}
